export const msalConfig = {

  auth: {
    authority: 'https://login.microsoftonline.com/533a72b0-15d7-4efd-9921-2c7d9041fb4a',
    clientId: '5a745384-bf13-4b5a-b5a1-644193dedec7',
    redirectUri: window.document.location.origin,
    postLogoutRedirectUri: window.document.location.origin,
    // scopes: ['api://676c3f61-a5a3-4311-adac-7d6707811fac/access_as_user'],
    scopes: [
      'openid',         // required for ID token
      'profile',        // gives name, family_name, given_name
      'email',          // gives email claim
      'api://676c3f61-a5a3-4311-adac-7d6707811fac/access_as_user'  // your custom API scope
    ]
  },
  system: {
    iframeHashTimeout: 10000,
  },
}

export const loginRequest = {
  scopes: msalConfig.auth.scopes,
}

export const loginRequestValidateUserName = {
  scopes: ['https://graph.microsoft.com/User.Read'],
}